import { createReducer, on } from '@ngrx/store';

import TrackingActions from './actions';
import { defaultTrackingState } from './state';

export const trackingReducer = createReducer(
    defaultTrackingState,
    on(TrackingActions.setLaunchDarklyActiveExperiment, (state, action) => {
        return {
            ...state,
            ldActiveExperiments: {
                ...state.ldActiveExperiments,
                [action.id]: true,
            },
        };
    }),
);
